import React, { useState, useEffect, useRef } from "react";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import PaySlipComponent from "../../../../components/PaySlipComponent";
import { useLocation } from 'react-router-dom';
import printJS from "print-js";
import { useNavigate } from 'react-router-dom';
import { FaSpinner } from "react-icons/fa";
import UAEPaySlipComponent from "../../../../components/UAEPaySlipComponent";
import NICLPaySlipComponent  from "../../../../components/NICLPaySlipComponent";

const PaymentSlip = () => {
  const [result, setResult] = useState([]);
  const [responseData, setResponseData] = useState({});
  const [pageLoading, setPageLoading] = useState(true);
  const navigate = useNavigate();

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const ID = query.get("ID");
  const ContactID = query.get("ContactID");
  const MonthID = query.get("MonthID");



  const [shiftId, setShiftID] = useState('')
  const fetchPayslipData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/show-payslip?MonthID=${MonthID}&EmployeeID=${ContactID}&ID=${ID}`
      );


      const payData = response?.data?.data || {};

      const ShiftID = response?.data?.employeeDetails?.[0]?.ShiftId
      setShiftID(ShiftID);

      setResult(payData);
      setResponseData(response);
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (ID && ContactID && MonthID) {
      fetchPayslipData();
    }
  }, [ID, ContactID, MonthID]);

  const componentRef = useRef(null);

  const handleBackClick = () => {
    navigate('/rujul/hrm/print-email-payslip');
  };

  const handlePrint = () => {
    printJS({
      printable: "printSection",
      type: "html",
      css: ["index.css"],
      scanStyles: false,
      style: `
      @page { 
        size: auto; 
        margin: 0mm !important; 
      }
      
      body {
        margin: 0 !important;
        padding: 0 !important;
        font-family: 'Source Sans Pro', sans-serif !important;
      }

      #printSection {
        padding: 0 !important;
        margin: 0 !important;
        font-family: 'Source Sans Pro', sans-serif !important;
      }
      * {
      font-family: 'Source Sans Pro', sans-serif !important;
      }
      .no-print {
        display: none !important;
      }
      
      /* General table styles */
      table {
        border-collapse: collapse !important;
        width: 100% !important;
        table-layout: fixed !important;
        margin-bottom: 10px;
        border: 0.5px solid #d3cacaff;
      }
      
      table th, table td {
        border: 0.5px solid #d3cacaff !important;
        text-align: left !important;
        word-wrap: break-word !important;
      }
      
      /* Payroll details table */
      #slipPayroll{
      font-size:12px !important;
      }
      #slipLogoHeader{
        width: 100% !important;
        display: flex !important;
        justify-content: space-between !important;
      }
      #txbdody{
      padding:0px 0px !important;
      font-weight: 700 !important; 
      color: black !important;
      }
      #payrollDetails th, #payrollDetails td {
        padding: 2px 3px !important;
        font-size: 12px !important;
      }
      
      #tablebodyAmount {
        text-align: right !important;
      }

      #totalEarning {
        font-weight: bold !important;
      }
      
      /* Employee details section */
      #payslipTableEmpHeader {
        margin-top: 10px !important;
      }
      #payslipTableHeader > th > h6{
      font-size:22px !important;
      }
      #customHrLine {
      display: block !important;
      visibility: visible !important;
      height: 1px !important;
      background-color: black !important;
      border: none !important;
      padding: 0px !important;
      margin: 10px 0 !important;
      margin-left: auto !important;
      margin-right: 0 !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      width: 52.5% !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      }

      #slipHeader{
       margin-left:72px !important;
      }
      #slipHeader > h6{
      color:#000 !important;
      font-size:16px !important;
      font-weight:500 !important;
      margin: 0px !important;
      padding: 0px !important;
      font-family: 'Source Sans Pro', sans-serif !important;
      }
      #slipHeader > p{
      color:#000 !important;
      font-size: 16px !important;
      margin: 0px !important;
      padding: 0px !important;
      font-family: 'Source Sans Pro', sans-serif !important;
      }
      #slipHeader > h5{
      color:#000 !important;
      font-size: 12px !important;
      margin: 10px 0px 5px 0px !important;
      padding: 0px !important;
      font-weight:400 !important;
      font-family: 'Source Sans Pro', sans-serif !important;
      }
      #payslipTableEmpHeader td {
        font-size: 12px !important;
        font-weight: normal !important;
      }

      /* Main payslip table adjustments */
      #payslipTable {
        border: transparent !important;
        padding: 0 !important;
        margin-top:10px !important;
      }
      
      #payslipTable th, #payslipTable td {
        border: transparent !important;
        padding: 2px !important;
        margin: 0 !important;
        font-weight: 500 !important;
      }

      #empDetail{
        border: transparent !important;
        padding: 0 !important;
        line-height: 0.9 !important;
        width: 95% !important;
        margin-top: 25px !important;
      }
        #empDetail th, #empDetail td{
        border: transparent !important;
        padding: 0 !important;
        margin: 0 !important;
        font-weight: 500 !important;
        }
        #empDetail tr {
        line-height: 0.9 !important;
        }

        #empDetail td {
        line-height: inherit !important;
        padding: 2px 0 !important;
        }

      /* Footer notes */
      #payableNote {
        margin-top: 10px !important;
        margin-left: -40px !important;
      }
      
      #payableNotes {
        margin-top: 220px !important;
      }
      
      #payableNoteDetails {
        display: flex !important;
        justify-content: center !important;
        text-align: center !important;
        margin-top: 10px !important;
        margin-left: 120px !important;
        font-size: 12px !important;
      }
      
      /* Income slab section */
      #incomeSlab {
        gap: 5px !important;
        display: flex !important;
        margin-top: 5px !important;
        margin-inline: 0px !important;
        width: 100% !important;
      }
      
      #incomeSlableft {
        width: 70% !important;
      }
      
      #incomeSlabright {
        width: 30% !important;
      }
      
      .tbl-heading-tx {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        background-color: #d1ecf1 !important;
      }
      
      /* Page break handling */
      .pageBreak {
        page-break-before: always !important;
      }
      
      /* Specific table styles for income calculation */
      .tdBorder {
        border: 0.5px solid #d3cacaff !important;
      }
      
      /* Color styles */
      .bg-white {
        background-color: white !important;
      }
      
      /* Text styles */
      .text-end {
        text-align: right !important;
      }
      
      .m-0 {
        margin: 0 !important;
      }
      
      .font-bold {
        font-weight: bold !important;
      }
      
      /* Responsive adjustments */
      @media print {
        body, #printSection {
          margin: 0 !important;
          padding: 0 !important;
        }
        
        .row {
          display: flex !important;
          flex-wrap: wrap !important;
        }
        
        .col-12 {
          flex: 0 0 100% !important;
          max-width: 100% !important;
        }
        
        .payslip-Card {
          background-color: #27568B !important;
          padding: 35px !important;
        }
        
        /* Ensure proper spacing */
        .h-auto {
          height: auto !important;
        }
        
        /* Make sure tables don't break across pages */
        table {
          page-break-inside: avoid !important;
        }
        
        tr {
          page-break-inside: avoid !important;
        }
      }
      
      /* Additional specific styles from your component */
      .remark-container {
        margin-bottom: 10px !important;
      }
      
      .remark {
        font-style: italic !important;
        font-weight: bold !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      
      .Table-header {
        background-color: #c9d5e2 !important;
      }
      
      .Table-info {
        background-color: #49719e !important;
        color: #fff !important;
      }
      
      .Table-info p {
        font-weight: bold !important;
        margin: 0 !important;
        padding: 6px 3px !important;
        font-size: 12px !important;
      }
      
      /* Ensure proper alignment for IT section tables */
      #itSectionTable {
        width: 100% !important;
        border-collapse: collapse !important;
        margin: 0 !important;
        padding: 0 !important;
        page-break-inside: avoid !important; 
      }
      #slipHeaderInfo{
      font-weight: 700 !important; 
      color: black !important;
      padding: 0px !important; 
      }
        #itSectionTable td:first-child {
        width: 80% !important;
      }
      
      #itSectionTable td:last-child {
        width: 20% !important;
      }
      #itSectionTable td {
        padding: 0px 2px !important;
        font-size: 12px !important;
        font-weight: normal !important;
      }
           #payableNotes {
        position: fixed;
        bottom: 20px;
        width: 100%;
        margin-top: 0 !important;
      }
      
      #payableNote {
        margin-left: 0 !important;
      }
      
      #payableNoteDetails {
        margin-left: 0 !important;
        text-align: center !important;
        width: 100%;
      }
      
      /* Ensure the notes stay on the last page */
      @page :last {
        #payableNotes {
          position: absolute;
          bottom: 0;
        }
      }
    `,
    });
  };


  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid mt-3">
          <div className="d-flex justify-content-end">
            <div className="d-flex gap-1 px-4">
              <div>
                <button className="custom-btn" onClick={handleBackClick}>Back</button>
              </div>
              <div>
                <button className="custom-btn" onClick={handlePrint}>Print</button>
              </div>
            </div>
          </div>
          <div>
            {shiftId === 7 ? (
              <NICLPaySlipComponent
                result={result}
                response={responseData}
                componentRef={componentRef}
              />
            ) : shiftId === 6 ? (
              <UAEPaySlipComponent
                result={result}
                response={responseData}
                componentRef={componentRef}
              />
            ) : (
              <PaySlipComponent
                result={result}
                response={responseData}
                componentRef={componentRef}
              />
            )}
          </div>
        </div>
      </>
    );
  }

};

export default PaymentSlip;
